import React, { useState, useMemo } from 'react';
import PropTypes from 'prop-types';
import { Tiles } from 'wsm-tiles';
import { PaginationProvider } from '../contexts/PaginationContext';
import { MOBILE_TILES_PER_PAGE } from '../global-constants';
import { paginateData } from '../utils/pagination';
import Pagination from './pagination/Pagination';
import '../global-sass/main.scss';

const MiniGridView = ({ data }) => {
	const [offset, setOffset] = useState(0);

	// Synchronous slice - no useEffect delay
	const visibleBodystyles = useMemo(
		() => paginateData(data || [], offset),
		[data, offset]
	);

	return (
		<PaginationProvider
			totalCount={data?.length || 0}
			onPageChange={setOffset}
			itemsPerPage={MOBILE_TILES_PER_PAGE}
			offset={offset}
		>
			<div className="w-100 pt-4">
				<Tiles
					type="bodystyle"
					data={visibleBodystyles}
					layout="grid"
					className="justify-content-center mini-grid"
				/>
			</div>
			<Pagination />
		</PaginationProvider>
	);
};

MiniGridView.propTypes = {
	data: PropTypes.arrayOf(
		PropTypes.shape({
			bodystyle: PropTypes.shape({
				styleName: PropTypes.string.isRequired,
				bodyStyleImgUrl: PropTypes.string.isRequired,
				href: PropTypes.string,
				iconColor: PropTypes.string.isRequired
			})
		})
	).isRequired
};

export default MiniGridView;
